<template>
  <div class="login-enter-code">
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <login-member-doesnt-exist-error v-else-if="memberDoesntExist" :phoneNumber="phoneNumber" />

    <div v-else>
      <img class="image-container" :src="require('@/assets/hero-login.svg')">
      <div class="content">
        <enter-code :phone-number="phoneNumber"
                    :confirm-code-action="authenticateAndProceed"
                    :regenerate-code-action="forceGenerateCode"
                    :server-error="serverErrors.authenticate"
                    :button-title="'כניסה'"
                    :loading="loading"
                    :reset-error="() => resetError('authenticate')"/>
        <login-support-footer :link-action="openLoginHelpModal" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import BaseUI from 'base-ui';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import router from '@/router';
import LoginMemberDoesntExistError from '@/pages/responsive-pages/non-authenticated/login/LoginMemberDoesntExistError';
import EnterCode from '../../../../base-components/EnterCode.vue';
import Segment from '../../../../Segment';
import CookiesDisabledError from '../../../general-errors/CookiesDisabledError.vue';
import LoginHelp from './steps/LoginHelp.vue';
import ModalBus from '../../../../event-bus/modal-bus';

export default {
  name: 'LoginEnterCode',
  components: {
    LoginSupportFooter: BaseUI.LoginSupportFooter,
    EnterCode,
    CookiesDisabledError,
    LoginMemberDoesntExistError,
  },
  data() {
    return {
      redirectTo: '',
      loading: false,
      memberDoesntExist: false,
    };
  },
  created() {
    this.redirectTo = this.$route.query.redirectTo || 'sr';
    if (!this.phoneNumber) {
      if (this.$route.query.phoneNumber) {
        this.setPhoneNumber(this.$route.query.phoneNumber);
      } else {
        this.redirectToLogin();
      }
    }
    Segment.trackUserGot('LoginEnterCodeEntered');
  },
  computed: {
    ...mapState('login', ['phoneNumber', 'serverErrors']),
    ...mapGetters('login', ['errorTypes']),
    cookiesDisabledError() {
      return this.serverErrors.authenticate === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapMutations('login', ['resetError', 'setPhoneNumber']),
    ...mapActions('login', ['authenticate', 'forceGenerateCode']),
    redirectToOldState() {
      const carryParams = _.omit(this.$route.query, ['redirectTo', 'phoneNumber']);
      router.push({ path: `/${this.redirectTo}`, query: carryParams });
    },
    redirectToLogin() {
      router.push({ path: '/login', query: this.$route.query });
    },
    async authenticateAndProceed(code) {
      Segment.trackUserInteraction('LoginCodeEnteredClicked');
      try {
        this.loading = true;
        const customerId = await this.authenticate(code);
        if (customerId) {
          this.redirectToOldState();
        } else {
          this.memberDoesntExist = true;
        }
      } finally {
        this.loading = false;
      }
    },
    openLoginHelpModal() {
      ModalBus.$emit('open', {
        component: LoginHelp,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .error-holder {
    margin: 30px;
  }

  .login-enter-code {
    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }
  }
</style>
